import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";

import SettingsInputHdmiOutlinedIcon from '@mui/icons-material/SettingsInputHdmiOutlined';

import api from "../service/api";
import { setError } from "../reducers/appSlice";

const FirmaToken = (props) => {
  const { adjuntoId, nombreAdjunto, handleFirmado, disabled } = props;
  const dispatch = useDispatch();
  const width = 850; // lo que mide de ancho la ventana popup
  const [width_pantalla] = useState(window.innerWidth); // lo que mide la pantalla completa

  const ajuste_orizontal = parseInt((width_pantalla - width) / 2);

  const handleClick = () => {
    api
      .firmarAdjuntoToken({ adjuntoId: adjuntoId, nombreArchivo: nombreAdjunto })
      .then((res) => {
        let ventanaFirmador = window.open(res.data.url, "", "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=850, height=800, top=10, left=" + ajuste_orizontal + "");
        if (ventanaFirmador) {
          let firmadorTimer = window.setInterval(function () {
            if (ventanaFirmador.closed !== false) {
              window.clearInterval(firmadorTimer);
              handleFirmado();
            }
          }, 200);
        } else {
          dispatch(setError("No se pudo abrir la ventana emergente"));
        }
      })
      .catch((e) =>
        dispatch(
          setError(e.response.data.error ? e.response.data.error : "Error")
        )
      );
  };

  return (
    <>
      <IconButton
        title="Firma Token"
        size="small"
        onClick={handleClick}
        disabled={disabled}
      >
        <SettingsInputHdmiOutlinedIcon fontSize="small" />
      </IconButton>
    </>
  );
};

FirmaToken.propTypes = {
  adjuntoId: PropTypes.number.isRequired,
  nombreAdjunto: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  actualizarAdjuntos: PropTypes.func.isRequired,
};

FirmaToken.defaultProps = {
  disabled: false,
};

export default FirmaToken;
